/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    BROADCAST_DELETE_CLEANUP_TABLE
 * Date:         2025-01-02
 * Modified By:  Cursor
 *
 * Description:
 * Remove debug logging after successful fix of refresh and pagination issues.
 *
 * File Size Check:
 * - Current: 482 lines
 * - Removing: ~15 lines
 * - Projected: 467 lines
 * - Decision: Proceed (Clean up)
 *
 * Related Screens / Modules:
 * - client/src/features/broadcast/pages/broadcasts-list/hooks/useBroadcastDelete.ts
 */
/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    BROADCAST_DELETE_SINGLE_ITEM_TABLE
 * Date:         2025-01-02
 * Modified By:  Cursor
 *
 * Description:
 * Update handleDelete to pass item.itemNo for single item deletion.
 * Updated modal text to reflect that ONLY the specific item is removed.
 *
 * File Size Check:
 * - Current: 477 lines
 * - Adding: ~5 lines
 * - Projected: 482 lines
 * - Decision: Proceed (Table logic)
 */
/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    BROADCAST_DELETE_DEBUG_TABLE
 * Date:         2025-01-02
 * Modified By:  Cursor
 *
 * Description:
 * Add debug logging to trace refresh callback execution after delete.
 *
 * File Size Check:
 * - Current: 467 lines
 * - Adding: ~10 lines
 * - Projected: 477 lines
 * - Decision: Proceed (Table component, debug logging)
 *
 * Related Screens / Modules:
 * - client/src/features/broadcast/pages/broadcasts-list/hooks/useBroadcastDelete.ts
 */
/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    BROADCASTS_FIX_DOUBLE_PAGINATION
 * Date:         2025-01-02
 * Modified By:  Cursor
 *
 * Description:
 * Fix double pagination bug. When data is already paginated by parent component
 * (BroadcastsTabs), the table should NOT apply pagination again. Added check
 * to skip table pagination when broadcasts array is already paginated.
 *
 * File Size Check:
 * - Current: 290 lines
 * - Modifying: ~3 lines
 * - Projected: 290 lines
 * - Decision: Proceed
 *
 * Related Screens / Modules:
 * - client/src/features/broadcast/pages/broadcasts-list/components/BroadcastsTabs.tsx
 * - client/src/features/broadcast/pages/broadcasts-list/utils/broadcastHelpers.ts
 */
/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    MYBROADCASTS_DELETE_INTEGRATION
 * Date:         2025-01-02
 * Modified By:  Cursor
 *
 * Description:
 * Integrate useBroadcastDelete hook for Delete functionality. Shows confirmation
 * modal, soft-deletes broadcast, displays success message, and refreshes screen.
 *
 * File Size Check:
 * - Current: 290 lines
 * - Adding: ~45 lines (modal + hook integration)
 * - Projected: 335 lines
 * - Decision: Proceed (table component, acceptable)
 *
 * Related Screens / Modules:
 * - client/src/features/broadcast/pages/broadcasts-list/hooks/useBroadcastDelete.ts
 * - client/src/services/broadcastService.ts
 */
/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    MYBROADCASTS_DELETE_CONFIRMATION
 * Date:         2025-01-02
 * Modified By:  Cursor
 *
 * Description:
 * Implement Delete functionality with confirmation modal. Uses new 
 * useBroadcastDelete hook to handle soft-deletion of entire broadcast groups.
 *
 * File Size Check:
 * - Current: 368 lines
 * - Adding: ~50 lines (modal + hook logic)
 * - Projected: 418 lines
 * - Decision: Proceed (Table component, complex interaction justifies size)
 *
 * Related Screens / Modules:
 * - client/src/features/broadcast/pages/broadcasts-list/hooks/useBroadcastDelete.ts
 */
/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    MYBROADCASTS_EDIT_NAVIGATION_FIX
 * Date:         2025-01-02
 * Modified By:  Cursor
 *
 * Description:
 * Correct Edit navigation route. Navigate to /broadcast/edit (instead of 
 * /broadcasts/create) with item data pre-populated in location state.
 *
 * File Size Check:
 * - Current: 348 lines
 * - Adding: ~20 lines
 * - Projected: 368 lines
 * - Decision: Proceed (Table component, logic is concise)
 *
 * Related Screens / Modules:
 * - client/src/pages/BroadcastEditPage.tsx (destination page)
 * - client/src/features/broadcast/BroadcastForm.tsx (receives templateItem)
 */
/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    MYBROADCASTS_EDIT_NAVIGATION
 * Date:         2025-01-02
 * Modified By:  Cursor
 *
 * Description:
 * Implement Edit functionality. Navigate to broadcast create page with item
 * data pre-populated, allowing user to modify and create new broadcast from
 * the existing item as a template.
 *
 * File Size Check:
 * - Current: 290 lines
 * - Adding: ~5 lines
 * - Projected: 295 lines
 * - Decision: Proceed
 *
 * Related Screens / Modules:
 * - client/src/pages/BroadcastCreatePage.tsx (destination page)
 * - client/src/features/broadcast/BroadcastForm.tsx (will receive pre-populated data)
 */
/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    RESEND_SINGLE_ITEM_FIX
 * Date:         2026-01-02
 * Modified By:  Cursor
 *
 * Description:
 * Update Resend functionality to send only the specific clicked item instead 
 * of the entire broadcast group. Updated handleResend to pass the full item 
 * object to the hook.
 *
 * File Size Check:
 * - Current: 289 lines
 * - Adding: ~20 lines (header)
 * - Projected: 309 lines
 * - Decision: Proceed (Table component, code lines ~183, under 200 limit)
 *
 * Related Screens / Modules:
 * - client/src/features/broadcast/pages/broadcasts-list/hooks/useBroadcastActions.ts
 */
/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    MYBROADCASTS_PHASE2_INTEGRATE_HOOK
 * Date:         2025-01-02
 * Modified By:  Cursor
 *
 * Description:
 * Integrate useBroadcastActions hook for Resend functionality. Replace
 * console.log placeholder with real API call. Add refreshCallback prop.
 *
 * File Size Check:
 * - Current: 259 lines
 * - Adding: ~15 lines
 * - Replacing: ~3 lines
 * - Projected: 271 lines
 * - Decision: Proceed (table component, acceptable)
 *
 * Related Screens / Modules:
 * - client/src/features/broadcast/pages/broadcasts-list/hooks/useBroadcastActions.ts
 * - client/src/features/broadcast/pages/broadcasts-list/components/BroadcastsTabContent.tsx (will pass refresh)
 */
/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    BROADCAST_ACTION_BUTTONS_PHASE1_FIX
 * Date:         2025-01-02
 * Modified By:  Cursor
 *
 * Description:
 * Phase 1: Add action buttons to "My Broadcasts" tab. Implements 1-second hover
 * delay before showing buttons. Buttons perform console.log only (Phase 1).
 * Buttons appear ONLY in "mine" tab, not in recent/wts/wtb tabs.
 *
 * File Size Check:
 * - Current: 161 lines
 * - Adding: ~60 lines
 * - Projected: 221 lines
 * - Decision: Proceed (table component, acceptable slightly over limit)
 *
 * Related Screens / Modules:
 * - client/src/features/broadcast/pages/broadcasts-list/components/BroadcastActionButtons.tsx
 * - client/src/components/broadcast/BroadcastItemCard.tsx (reverted - not used here)
 */
/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    ALLBROADCASTS_SIDEBAR_FILTER
 * Date:         2026-01-01
 * Modified By:  Cursor
 *
 * Description:
 * Update navigation links from /broadcasts to /allbroadcasts.
 *
 * File Size Check:
 * - Current: 143 lines
 * - Adding: ~15 lines
 * - Projected: 158 lines
 * - Decision: Proceed (within 200-line component limit)
 *
 * Related Screens / Modules:
 * - client/src/features/dashboard/DashboardBroadcastSummaryTable.tsx
 */
/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    BROADCAST_SUMMARY_NAVIGATION
 * Date:         2025-12-29
 * Modified By:  Cursor
 *
 * Description:
 * Added double-click navigation to broadcast details and cursor: pointer
 * for rows. Refactored helper functions to external utility file.
 *
 * File Size Check:
 * - Current: 198 lines
 * - Projected: ~130 lines
 * - Decision: Proceed (Cleanly within 200-line limit after refactoring)
 *
 * Related Screens / Modules:
 * - client/src/features/dashboard/DashboardBroadcastSummaryTable.tsx
 * - client/src/features/broadcast/pages/broadcast-details/BroadcastDetailsPage.tsx
 */

/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    MOBILE_TABLET_MIGRATION_PHASE3
 * Date:         2026-02-09
 * Modified By:  Claude
 *
 * Description:
 * Added mobile responsive support with Desktop/Mobile component split.
 * Mobile devices show card-based layout, desktop shows table layout.
 *
 * Related Screens / Modules:
 * - client/src/features/dashboard/DashboardBroadcastSummaryTable.tsx
 * - client/src/features/dashboard/components/MobileBroadcastList.tsx
 * - client/src/features/dashboard/components/DesktopBroadcastTable.tsx
 */

// [2026-02-07] style-extraction: moved inline styles to SCSS module
import React, { useState } from "react"; // [2025-01-02] Action buttons: Added useState for "mine" tab hover functionality
import { useNavigate } from "react-router-dom";
import { Broadcast, BroadcastItem, UserInfo } from "../../interfaces/broadcast";
import styles from "./DashboardBroadcastTabs.module.scss";
import {
  formatRelativeTime,
  getConditionBackgroundColor,
  getConditionTextColor
} from "./utils/broadcastHelpers";
// [2026-02-13] CURRENCY_PHASE2: Centralized single-price display
import { formatCurrency } from "../../utils/priceDisplay";
import { BroadcastActionButtons } from "../broadcast/pages/broadcasts-list/components/BroadcastActionButtons"; // [2025-01-02] Action buttons: Import for "mine" tab hover functionality
import { useBroadcastActions } from '../broadcast/pages/broadcasts-list/hooks/useBroadcastActions'; // [2025-01-02] Phase 2: Resend functionality
import { useBroadcastDelete } from '../broadcast/pages/broadcasts-list/hooks/useBroadcastDelete'; // [2025-01-02] Delete with confirmation
import { useMediaQuery } from "../../hooks/useMediaQuery"; // [2026-02-09] Mobile: Responsive rendering
import { MobileBroadcastList } from "./components/MobileBroadcastList"; // [2026-02-09] Mobile: Card-based view

// Flattened item with broadcast metadata
interface FlatItem extends BroadcastItem {
  broadcastType: "WTB" | "WTS";
  broadcastId: string;
  createdAt: string;
  userId: string | UserInfo;
  status?: "draft" | "sent" | "archived" | "deleted";
  sentAt?: string | null;
}

type Props = {
  broadcasts: Broadcast[];
  currentTab?: "recent" | "wts" | "wtb" | "mine"; // Current tab to conditionally show Type column
  itemsPerPage?: number; // Limit number of items to display
  currentPage?: number; // Current page for pagination
  refreshCallback?: () => void; // [2025-01-02] Phase 2: Refresh after resend
  resetPage?: () => void;
  showMobileFooter?: boolean;   // [2026-02-10] Show company name in mobile footer
  showMobileActions?: boolean;  // [2026-02-10] Show Edit/Delete in mobile footer
};

const DashboardBroadcastSummaryTable: React.FC<Props> = ({
  broadcasts,
  currentTab,
  itemsPerPage,
  currentPage = 1,
  refreshCallback = () => {},
  resetPage = () => {}, // [2026-01-02] Added resetPage with default noop
  showMobileFooter,     // [2026-02-10] Mobile footer props
  showMobileActions,    // [2026-02-10] Mobile actions props
}) => {
  const navigate = useNavigate();
  // [2026-02-13] Maya: Show mobile cards for both mobile and tablet
  const { isMobile, isTablet } = useMediaQuery();

  // [2025-01-02] Wrap refresh callback
  const handleRefresh = () => {
    if (refreshCallback) {
      refreshCallback();
    }
  };

  // [2025-01-02] Phase 2: Use hook for resend functionality
  const { handleResend: hookHandleResend, isResending } = useBroadcastActions(handleRefresh);

  // [2026-06-25] DELETE-FIX: immediate delete, no confirmation modal
  const {
    handleDelete: hookHandleDelete,
    isDeleting,
  } = useBroadcastDelete();

  // [2025-01-02] Hover state remains unchanged from Phase 1
  const [showButtonsForRow, setShowButtonsForRow] = useState<string | null>(null);
  const [hoverTimeouts, setHoverTimeouts] = useState<Record<string, NodeJS.Timeout>>({});

  // [2025-01-02] Hover handlers remain unchanged from Phase 1
  const handleRowMouseEnter = (itemId: string) => {
    // setHoveredRowId(itemId);
    const timeout = setTimeout(() => {
      setShowButtonsForRow(itemId);
    }, 1000);
    setHoverTimeouts(prev => ({ ...prev, [itemId]: timeout }));
  };

  const handleRowMouseLeave = (itemId: string) => {
    // setHoveredRowId(null);
    setShowButtonsForRow(null);
    const timeout = hoverTimeouts[itemId];
    if (timeout) {
      clearTimeout(timeout);
      setHoverTimeouts(prev => {
        const newTimeouts = { ...prev };
        delete newTimeouts[itemId];
        return newTimeouts;
      });
    }
  };

  // [2026-01-02] Phase 2: Real resend handler - sends single item only
  const handleResend = (item: any) => {
    hookHandleResend(item);
  };

  // [2025-01-02] Phase 3: Edit handler - navigate to edit page with item as template
  const handleEdit = (item: any) => {
    // [2025-01-02] Navigate to broadcast edit page with item data in state
    navigate('/broadcast/edit', {
      state: {
        templateItem: {
          manufacturer: item.manufacturer,
          partNumber: item.partNumber,
          model: item.model,
          quantity: item.quantity,
          condition: item.condition,
          price: item.price,
          currency: item.currency,
          categories: item.categories,
          description: item.description,
        },
        type: item.broadcastType, // WTB or WTS
      }
    });
  };

  // [2026-06-25] DELETE-FIX: Delete handler - deletes immediately (no confirmation)
  const handleDelete = (item: any) => {
    hookHandleDelete(item.broadcastId, item.itemNo, handleRefresh, resetPage);
  };

  // [2025-12-29] Flatten broadcasts into individual items
  // [2026-01-29] dashboard-recent-interleave: For recent/wts/wtb preview, interleave items across groups
  // so one large broadcast group doesn't consume all rows.
  const HARD_ROW_LIMIT = 5;
  const rowLimit = typeof itemsPerPage === "number" && itemsPerPage > 0 ? itemsPerPage : HARD_ROW_LIMIT;

  const displayedItems: FlatItem[] = (() => {
    // [2026-07-07] Ronen: ALL broadcast rows must be sorted by date, most recent first.
    // Flatten every group's items (carrying the group date), sort by sentAt||createdAt DESC,
    // then take the preview rows. Replaces the old round-robin interleave, which alternated
    // items across groups and could show an older row above a newer one.
    const flattened: FlatItem[] = broadcasts.flatMap((b) => {
      const items = b.broadcast || b.items || [];
      return items.map((item) => ({
        ...item,
        broadcastType: b.type,
        broadcastId: b._id,
        createdAt: b.createdAt,
        userId: b.userId,
        status: b.status,
        sentAt: b.sentAt,
      }));
    });
    flattened.sort((a, b) => {
      const da = new Date(a.sentAt || a.createdAt || 0).getTime();
      const db = new Date(b.sentAt || b.createdAt || 0).getTime();
      return db - da; // most recent first
    });
    return flattened.slice(0, rowLimit);
  })();

  if (!displayedItems.length) {
    return (
      <div className="text-center py-5">
        <div className="fw-semibold mb-1">No broadcasts found</div>
        <div className="text-muted">Create a broadcast to see it here.</div>
      </div>
    );
  }

  // Show Type column only in "recent" and "mine" tabs
  const showTypeColumn = currentTab === "recent" || currentTab === "mine";

  // [2026-02-13] Maya: Render card-based list on mobile and tablet devices
  if (isMobile || isTablet) {
    return (
      <>
        <MobileBroadcastList
          items={displayedItems}
          showTypeColumn={showTypeColumn}
          showFooter={showMobileFooter}
          showActions={showMobileActions}
          onItemClick={(item) =>
            navigate(`/allbroadcasts/item/${item.broadcastId}/${item.itemNo}`)
          }
          onEdit={(item) => handleEdit(item)}
          onDelete={(item) => handleDelete(item)}
        />
      </>
    );
  }

  // Desktop: Standard table view
  return (
    <div className={`table-responsive ${styles.tableResponsive}`}>
      <table className={`table table-hover align-middle ${styles.broadcastTable}`}>
        <tbody>
          {displayedItems.map((item, idx) => {
            const rowId = `${item.broadcastId}-${idx}`;
            const isMinTab = currentTab === "mine";
            
            return (
              <tr
                key={rowId}
                className={styles.clickableRow}
                onClick={() => navigate(`/allbroadcasts/item/${item.broadcastId}/${item.itemNo}`)}
                onMouseEnter={() => {
                  // [2025-01-02] Only add hover for "mine" tab
                  if (isMinTab) {
                    handleRowMouseEnter(rowId);
                  }
                }}
                onMouseLeave={() => {
                  // [2025-01-02] Only handle hover for "mine" tab
                  if (isMinTab) {
                    handleRowMouseLeave(rowId);
                  }
                }}
                title="Click to view details"
              >
                {showTypeColumn && (
                  <td>
                    <span
                      className="badge"
                      style={{
                        backgroundColor:
                          item.broadcastType === "WTB"
                            ? "var(--color-brand-primary)"
                            : "var(--color-status-blue)",
                        color: "var(--color-white)",
                      }}
                    >
                      {item.broadcastType}
                    </span>
                  </td>
                )}
                <td className="u-H4-18-bold">{item.manufacturer || "—"}</td>
                <td className="u-H4-18-bold">{item.partNumber || "—"}</td>
                <td className="u-P3-14-medium">
                  <span
                    style={{
                      backgroundColor: getConditionBackgroundColor(item.condition),
                      color: getConditionTextColor(item.condition),
                      padding: "4px 8px",
                      borderRadius: "4px",
                      display: "inline-block",
                    }}
                  >
                    {item.condition || "—"}
                  </span>
                </td>
                <td className="u-P3-14-medium">QTY: {item.quantity ?? "—"}</td>
                <td className="u-Label-12-medium">{formatRelativeTime(item.sentAt || item.createdAt)}</td>
                <td className={`u-P1-18-semi-bold ${styles.priceCell}`}>
                  {formatCurrency(item.price, item.currency, (item as any).convertedPrice, (item as any).displayCurrency) || "N/A"}
                  
                  {/* [2025-01-02] Action buttons: Show ONLY in "mine" tab */}
                  {isMinTab && (
                    <BroadcastActionButtons
                      visible={showButtonsForRow === rowId}
                      isLoading={isResending || isDeleting} // [2025-01-02] Show loading for delete too
                      onResend={() => handleResend(item)} // [2026-01-02] Pass full item for single-item resend
                      onEdit={() => handleEdit(item)} // [2025-01-02] Pass full item for edit
                      onDelete={() => handleDelete(item)} // [2025-01-02] Pass item for delete
                    />
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DashboardBroadcastSummaryTable;
